import { mapMutations } from 'vuex';
import breadcrumb from '@/store/modules/breadcrumb';

export default {
  methods: {
    ...mapMutations('breadcrumb', {
      setBreadcrumbs: 'set',
      pushBreadcrumb: 'push',
      popBreadcrumb: 'pop',
      replaceBreadcrumb: 'replace',
      emptyBreadcrumbs: 'empty',
    }),
    handleBreadcrumbs() {
      if (this.breadcrumbs) {
        this.setBreadcrumbs(this.breadcrumbs);
      } else {
        this.setBreadcrumbs([]);
      }
    },
  },
  created() {
    this.handleBreadcrumbs();
  },
  watch: {
    breadcrumbs() {
      this.handleBreadcrumbs();
    },
  },
};
